<template>
  <v-card
    elevation="2"
    class="pa-3"
  >
    <v-form
      v-model="valid"
      ref="form"
    >
      <page-title
        icon="mdi-pencil-box-outline"
        sub="Menus do site"
        home="/admin"
      />
      <input
        id="user-id"
        type="hidden"
        v-model="menu.usuario"
      />
      <input
        id="menu-id"
        type="hidden"
        v-model="menu.id"
      />
      <input
        id="menu-uuid"
        type="hidden"
        v-model="menu.uuid"
      />
      <v-row>
        <v-col
          cols="12"
          md="2"
        >
          <v-text-field
            v-model="codigo"
            label="Código"
            outlined
            dense
          >
            <v-icon
              slot="append"
              color="success"
              large
              @click="loadDialog"
            >
              mdi-magnify
            </v-icon>
          </v-text-field>
        </v-col>
        <v-col
          cols="12"
          md="3"
          v-if="codigo"
        >
          <v-checkbox
            v-model="menu.inativar"
            label="Inativar menu ?"
            color="success"
            v-show="mode === 'save'"
          >
          </v-checkbox>
        </v-col>
      </v-row>
      <v-row>
        <v-col
          cols="12"
          md="3"
        >
          <v-autocomplete
            v-model="menu.grupoId"
            :items="grupos"
            outlined
            dense
            label="Grupo do menu:"
            @change="loadParent"
            v-if="mode === 'save'"
          ></v-autocomplete>
        </v-col>
        <v-col
          cols="12"
          md="3"
        >
          <v-autocomplete
            v-model="menu.parentId"
            :items="parent"
            outlined
            dense
            label="Sub Grupo:"
            persistent-hint
            hint="Somente para menu"
            v-if="mode === 'save'"
          ></v-autocomplete>
        </v-col>
        <v-col
          cols="12"
          md="2"
        >
          <v-text-field
            v-model="menu.menu"
            label="Chave do menu"
            outlined
            dense
            hint="Este campo é somente para subgrupo,Ex. Informação(P1,P2...)"
          >
          </v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col
          cols="12"
          md="4"
        >
          <v-text-field
            v-model="menu.nome"
            label="Nome do menu"
            outlined
            required
            dense
            hint="Nome que vai aparecer no menu(Folha de Pagamento)"
            v-if="mode === 'save'"
          ></v-text-field>
        </v-col>
        <v-col
          cols="12"
          md="4"
        >
          <v-text-field
            v-model="menu.url_int"
            label="Url interna"
            outlined
            required
            dense
            hint="Ex:Subg.=>Recurs.Human. (/hr) Menu=>Folha de pagamento (/hr/folha-de-pagamento)"
            v-if="mode === 'save'"
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col
          cols="12"
          md="4"
        >
          <v-text-field
            v-model="menu.component"
            label="Nome do component"
            outlined
            required
            dense
            hint="Nome do component ex.: MeuComponent"
            v-if="mode === 'save'"
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col
          cols="12"
          md="3"
        >
          <v-text-field
            v-model="menu.pagina"
            label="Página relacionada"
            outlined
            required
            dense
            hint="Somente para subgrupo"
            v-if="mode === 'save'"
          ></v-text-field>
        </v-col>
        <v-col
          cols="12"
          md="3"
        >
          <v-text-field
            v-model="menu.bloco"
            label="Bloco da página"
            outlined
            required
            dense
            hint="Somente para subgrupo, Ex: LD,LE,TP,BT ou CT"
            v-if="mode === 'save'"
          ></v-text-field>
        </v-col>
        <v-col
          cols="12"
          md="2"
        >
          <v-text-field
            v-model="menu.posicao"
            label="Posição do menu"
            outlined
            required
            dense
            hint="Somente para menus, Ex: 1,2,3..."
            v-if="mode === 'save'"
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col
          cols="12"
          md="8"
        >
          <v-textarea
            v-model="menu.ds_menu"
            label="Descrição"
            auto-grow
            outlined
            rows="3"
            row-height="25"
            dense
            v-if="mode === 'save'"
          ></v-textarea>
        </v-col>
      </v-row>
      <v-card>
        <v-tabs
          v-model="tabs"
          height="45"
        >
          <v-tab>
            <v-icon class="mr-2">
              mdi-settings
            </v-icon>
            Config
          </v-tab>
          <v-tab @click="loadSubmenus">
            <v-icon class="mr-2">
              mdi-note-text
            </v-icon>
            Submenus
          </v-tab>
        </v-tabs>
        <v-divider></v-divider>
        <v-tabs-items v-model="tabs">
          <v-tab-item>
            <v-card flat>
              <v-row justify="space-around">
                <v-col
                  cols="12"
                  md="12"
                >
                  <v-card>
                    <v-card-title>
                      Configurações do menu
                    </v-card-title>
                    <v-row>
                      <v-col
                        cols="12"
                        md="3"
                      >
                        <v-text-field
                          v-model="menu.mdi_menu"
                          label="Ícone formato mdi"
                          outlined
                          required
                          dense
                          hint="Ex.: account-group"
                          v-if="mode === 'save'"
                        >
                          <v-icon
                            slot="append"
                            color="green"
                            x-large
                          >
                            mdi-{{ menu.mdi_menu }}
                          </v-icon>
                        </v-text-field>
                      </v-col>
                      <v-col
                        cols="12"
                        md="3"
                      >
                        <v-text-field
                          v-model="menu.icon"
                          label="Ícone formato svg"
                          outlined
                          required
                          dense
                          hint="Ex.: mdiAccountGroup"
                          v-if="mode === 'save'"
                        >
                        </v-text-field>
                      </v-col>
                      <v-col
                        cols="12"
                        md="2"
                      >
                        <v-text-field
                          v-model="menu.size"
                          label="Size"
                          outlined
                          required
                          dense
                          hint="Ex.: lg"
                          v-if="mode === 'save'"
                        ></v-text-field>
                      </v-col>
                      <v-col
                        cols="12"
                        md="2"
                      >
                        <v-text-field
                          v-model="menu.menu_color"
                          label="Cor do menu"
                          outlined
                          required
                          dense
                          v-if="mode === 'save'"
                        ></v-text-field>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col
                        cols="12"
                        md="4"
                      >
                        <v-text-field
                          v-model="menu.png_menu"
                          label="Ícone do tipo png"
                          outlined
                          required
                          dense
                          v-if="mode === 'save'"
                        ></v-text-field>
                        <v-img
                          v-if="menu.icone_url_menu"
                          lazy-src="https://picsum.photos/id/11/10/6"
                          max-height="70"
                          max-width="70"
                          :src="menu.icone_url_menu"
                        ></v-img>
                      </v-col>
                      <v-col
                        cols="12"
                        md="6"
                      >
                        <v-btn
                          color="success"
                          class="ml-4 mb-2"
                          v-if="codigo"
                          @click="loadAddFoto"
                        >
                          <v-icon left>
                            mdi-camera
                          </v-icon>
                          Adicionar ícone png
                        </v-btn>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col
                        cols="12"
                        md="2"
                      >
                        <v-checkbox
                          v-model="menu.interna"
                          label="Usar url externa?"
                          color="success"
                          class="mt-0 mb-2"
                          v-show="mode === 'save'"
                        ></v-checkbox>
                      </v-col>
                      <v-col
                        cols="12"
                        md="2"
                      >
                        <v-checkbox
                          v-model="menu.interno"
                          label="Menu interno?"
                          color="success"
                          class="mt-0 mb-2"
                          v-show="mode === 'save'"
                        ></v-checkbox>
                      </v-col>
                      <v-col
                        cols="12"
                        md="2"
                      >
                        <v-autocomplete
                          v-model="menu.target_url"
                          :items="targets"
                          required
                          dense
                          outlined
                          label="Target"
                        >
                        </v-autocomplete>
                      </v-col>
                      <v-col
                        cols="12"
                        md="6"
                      >
                        <v-text-field
                          v-model="menu.url_ext"
                          label="Url externa"
                          outlined
                          required
                          dense
                          v-if="mode === 'save'"
                        ></v-text-field>
                      </v-col>
                    </v-row>
                  </v-card>
                </v-col>
              </v-row>
            </v-card>
          </v-tab-item>
          <v-tab-item>
            <v-card flat>
              <v-row justify="space-around">
                <v-col
                  cols="12"
                  md="12"
                >
                  <v-card>
                    <v-card-title>
                      Submenus
                    </v-card-title>
                    <v-data-table
                      :headers="headersSub"
                      :items="submenus"
                    >
                      <template v-slot:[`item.actions`]="{ item }">
                        <v-icon
                          medium
                          color="primary"
                          class="mr-2"
                          @click="loadSub(item)"
                        >
                          mdi-square-edit-outline
                        </v-icon>
                        <v-icon
                          medium
                          color="error"
                          class="mr-2"
                          @click="loadSub(item, 'remove')"
                        >
                          mdi-delete
                        </v-icon>
                      </template>
                    </v-data-table>
                    <v-row>
                      <v-col
                        cols="12"
                        md="6"
                      >
                        <v-btn
                          color="success"
                          class="ml-4 mb-2"
                          v-if="codigo"
                          @click="loadAddSub"
                        >
                          <v-icon left>
                            mdi-camera
                          </v-icon>
                          Adicionar submenu
                        </v-btn>
                      </v-col>
                    </v-row>
                  </v-card>
                </v-col>
              </v-row>
            </v-card>
          </v-tab-item>
        </v-tabs-items>
      </v-card>
      <v-row class="mt-4">
        <v-col
          cols="12"
          md="10"
        >
          <v-btn
            :disabled="!valid"
            color="success"
            class="mr-4"
            v-if="mode === 'save'"
            @click="save"
          >
            <v-icon left>
              mdi-content-save
            </v-icon>
            Salvar
          </v-btn>
          <v-btn
            color="error"
            class="mr-4"
            v-if="mode === 'remove'"
            @click="remove"
          >
            <v-icon left>
              mdi-content-save
            </v-icon>
            Deletar
          </v-btn>
          <v-btn
            color="secondary"
            class="mr-4"
            @click="reset"
          >
            <v-icon left>
              mdi-broom
            </v-icon>
            Limpar
          </v-btn>
        </v-col>
      </v-row>
    </v-form>
    <v-row justify="space-around">
      <v-col cols="auto">
        <v-dialog
          v-model="dialog"
          transition="dialog-bottom-transition"
          fullscreen
        >
          <template v-slot:default="dialog">
            <v-card>
              <v-toolbar
                color="primary"
                dark
              >
                Pesquisar menus
              </v-toolbar>
              <v-card-title>
                <v-text-field
                  class="search"
                  v-model="search"
                  append-icon="mdi-magnify"
                  label="Pesquisar"
                  single-line
                  hide-details
                >
                </v-text-field>
              </v-card-title>
              <v-data-table
                :headers="headers"
                :items="menus"
                :search="search"
              >
                <template v-slot:[`item.actions`]="{ item }">
                  <v-icon
                    medium
                    color="primary"
                    class="mr-2"
                    @click="loadMenu(item)"
                  >
                    mdi-square-edit-outline
                  </v-icon>
                  <v-icon
                    medium
                    color="error"
                    class="mr-2"
                    @click="loadMenu(item, 'remove')"
                  >
                    mdi-delete
                  </v-icon>
                </template>
              </v-data-table>
              <v-card-actions class="justify-end">
                <v-btn
                  color="error"
                  @click="dialog.value = false"
                >Fechar</v-btn>
              </v-card-actions>
            </v-card>
          </template>
        </v-dialog>
      </v-col>
    </v-row>
    <v-container>
      <v-dialog
        v-model="addSubmenu"
        transition="dialog-top-transition"
      >
        <template v-slot:default="dialog">
          <v-card>
            <v-toolbar
              color="primary"
              dark
            >
              Submenus
            </v-toolbar>
            <v-card
              elevation="2"
              class="pa-3"
            >
              <div class="ma-5">
                <PageTitle
                  icon="mdi-pencil-box-outline"
                  sub="Submenus do site"
                />
                <v-form>
                  <input
                    id="submenu-id"
                    type="hidden"
                    v-model="submenu.id"
                  />
                  <input
                    id="submenu-uuid"
                    type="hidden"
                    v-model="submenu.uuid"
                  />
                  <input
                    id="submenu-user"
                    type="hidden"
                    v-model="submenu.usuario"
                  />
                  <v-row>
                    <v-col
                      cols="12"
                      md="2"
                    >
                      <v-text-field
                        v-model="codigo"
                        label="Código"
                        dense
                        filled
                      >
                      </v-text-field>
                    </v-col>
                    <v-col
                      cols="12"
                      md="3"
                      v-if="codigo"
                    >
                      <v-checkbox
                        v-model="submenu.inativar"
                        label="inativar submenu?"
                        color="success"
                        class="mt-0 mb-2"
                        v-show="mode === 'save'"
                      ></v-checkbox>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col
                      cols="12"
                      md="6"
                    >
                      <v-text-field
                        v-model="submenu.nome"
                        label="Nome do submenu"
                        outlined
                        required
                        dense
                        hint="Nome que vai aparecer no menu(Folha de Pagamento)"
                        v-if="mode === 'save'"
                      ></v-text-field>
                    </v-col>
                    <v-col
                      cols="12"
                      md="2"
                    >
                      <v-text-field
                        v-model="submenu.posicao"
                        label="Posicao submenu"
                        outlined
                        required
                        dense
                        hint="Somente para menus, Ex: 1,2,3..."
                        v-if="mode === 'save'"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col
                      cols="12"
                      md="8"
                    >
                      <v-text-field
                        v-model="submenu.url_int"
                        label="Url interna"
                        outlined
                        required
                        dense
                        hint="Ex:Subg.=>Recurs.Human. (/hr) Menu=>Folha de pagamento (/hr/folha-de-pagamento)"
                        v-if="mode === 'save'"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col
                      cols="12"
                      md="8"
                    >
                      <v-textarea
                        v-model="submenu.ds_menu"
                        label="Descrição"
                        auto-grow
                        outlined
                        rows="1"
                        dense
                        v-if="mode === 'save'"
                      >
                      </v-textarea>
                    </v-col>
                  </v-row>
                </v-form>
              </div>
              <v-card-actions class="justify-end">
                <v-btn
                  color="success"
                  class="mr-4"
                  v-if="codigo"
                  type="submit"
                  @click="addSair"
                >
                  <v-icon left>
                    mdi-content-save
                  </v-icon>
                  Salvar e sair
                </v-btn>
                <v-btn
                  color="success"
                  class="mr-4"
                  v-if="codigo"
                  type="submit"
                  @click="addCont"
                >
                  <v-icon left>
                    mdi-content-save
                  </v-icon>
                  Salvar e continuar
                </v-btn>
                <v-btn
                  color="error"
                  class="mr-4"
                  v-if="codigo"
                  @click="resetSub"
                >
                  Limpar
                  <v-icon left>
                    mdi-broom
                  </v-icon>
                </v-btn>
                <v-btn
                  color="danger"
                  class="mr-4"
                  @click="dialog.value = false"
                >
                  Sair
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-card>
        </template>
      </v-dialog>
    </v-container>
    <!-- tela de atualização do submenuu -->
    <v-container>
      <v-dialog
        v-model="editSubmenu"
        transition="dialog-top-transition"
      >
        <template v-slot:default="dialog">
          <v-card>
            <v-toolbar
              color="primary"
              dark
            >
              Submenu
            </v-toolbar>
            <v-card
              elevation="2"
              class="pa-3"
            >
              <div class="ma-5">
                <PageTitle
                  icon="mdi-pencil-box-outline"
                  sub="Editar Submenus do site"
                />
                <v-form>
                  <input
                    id="submenu-id"
                    type="hidden"
                    v-model="submenu.id"
                  />
                  <v-row>
                    <v-col
                      cols="12"
                      md="2"
                    >
                      <v-text-field
                        v-model="codigo"
                        label="Código"
                        dense
                        filled
                      >
                      </v-text-field>
                    </v-col>
                    <v-col
                      cols="12"
                      md="3"
                      v-if="codigo"
                    >
                      <v-checkbox
                        v-model="submenu.inativar"
                        label="inativar submenu?"
                        color="success"
                        class="mt-0 mb-2"
                        v-show="mode === 'save'"
                      ></v-checkbox>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col
                      cols="12"
                      md="3"
                    >
                      <v-text-field
                        v-model="submenu.nome"
                        label="Nome do menu"
                        outlined
                        required
                        dense
                        hint="Nome que vai aparecer no menu(Folha de Pagamento)"
                        v-if="mode === 'save'"
                      ></v-text-field>
                    </v-col>
                    <v-col
                      cols="12"
                      md="5"
                    >
                      <v-textarea
                        v-model="submenu.ds_menu"
                        label="Descrição"
                        auto-grow
                        outlined
                        rows="1"
                        dense
                        v-if="mode === 'save'"
                      >
                      </v-textarea>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col
                      cols="12"
                      md="4"
                    >
                      <v-text-field
                        v-model="submenu.component"
                        label="Nome do Component"
                        outlined
                        dense
                        hint="Exemplo: MeuComponent"
                        v-if="mode === 'save'"
                      >
                      </v-text-field>
                    </v-col>
                    <v-col
                      cols="12"
                      md="4"
                    >
                      <v-text-field
                        v-model="submenu.url_int"
                        label="Url interna"
                        outlined
                        required
                        dense
                        hint="Nome que vai aparecer no menu(Folha de Pagamento)"
                        v-if="mode === 'save'"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col
                      cols="12"
                      md="4"
                    >
                      <v-text-field
                        v-model="submenu.mdi_menu"
                        label="Ícone do tipo icon"
                        outlined
                        required
                        dense
                        hint="Exemplo(mdi-icone-nome)"
                        v-if="mode === 'save'"
                      >
                        <v-icon
                          slot="append"
                          color="green"
                          x-large
                        >
                          mdi-{{ submenu.mdi_menu }}
                        </v-icon>
                      </v-text-field>
                    </v-col>
                    <v-col
                      cols="12"
                      md="4"
                    >
                      <v-text-field
                        v-model="submenu.icon"
                        label="Ícone formato svg"
                        outlined
                        required
                        dense
                        hint="Ex.: mdiAccountGroup"
                        v-if="mode === 'save'"
                      >
                      </v-text-field>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col
                      cols="12"
                      md="3"
                    >
                      <v-text-field
                        v-model="submenu.size"
                        label="Size"
                        outlined
                        required
                        dense
                        hint="Ex.: lg"
                        v-if="mode === 'save'"
                      ></v-text-field>
                    </v-col>
                    <v-col
                      cols="12"
                      md="3"
                    >
                      <v-text-field
                        v-model="submenu.menu_color"
                        label="Cor do menu"
                        outlined
                        required
                        dense
                        hint="Exemplo(green) para tailwindcss"
                        v-if="mode === 'save'"
                      >
                      </v-text-field>
                    </v-col>
                    <v-col
                      cols="12"
                      md="2"
                    >
                      <v-checkbox
                        v-if="submenu.mdi_menu"
                        v-model="submenu.pngicon"
                        label="Usar este icone?"
                        color="success"
                        class="mt-0 mb-2"
                        v-show="mode === 'save'"
                      ></v-checkbox>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col
                      cols="12"
                      md="4"
                    >
                      <v-text-field
                        v-model="submenu.png_menu"
                        label="Ícone do tipo png"
                        outlined
                        required
                        dense
                        v-if="mode === 'save'"
                      ></v-text-field>
                      <v-img
                        lazy-src="https://picsum.photos/id/11/10/6"
                        max-height="40"
                        max-width="130"
                        :src="submenu.icone_link_menu"
                      ></v-img>
                    </v-col>
                    <v-col
                      cols="12"
                      md="6"
                    >
                      <v-btn
                        color="success"
                        class="ml-4 mb-2"
                        v-if="codigo"
                        @click="loadAddFotoSub"
                      >
                        <v-icon left>
                          mdi-camera
                        </v-icon>
                        Adicionar ícone png
                      </v-btn>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col
                      cols="12"
                      md="2"
                    >
                      <v-checkbox
                        v-model="submenu.interna"
                        label="Usar url externa?"
                        color="success"
                        class="mt-0 mb-2"
                        v-show="mode === 'save'"
                      ></v-checkbox>
                    </v-col>
                    <v-col
                      cols="12"
                      md="2"
                    >
                      <v-autocomplete
                        v-model="submenu.target_url"
                        :items="targets"
                        required
                        dense
                        outlined
                        label="Target"
                      >
                      </v-autocomplete>
                    </v-col>
                    <v-col
                      cols="12"
                      md="6"
                    >
                      <v-text-field
                        v-model="submenu.link_ext"
                        label="Url externa"
                        outlined
                        required
                        dense
                        v-if="mode === 'save'"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </v-form>
              </div>
              <v-card-actions class="justify-end">
                <v-btn
                  color="success"
                  class="mr-4"
                  v-if="codigo"
                  type="submit"
                  @click="saveSub"
                >
                  <v-icon left>
                    mdi-content-save
                  </v-icon>
                  Atualizar
                </v-btn>
                <v-btn
                  color="error"
                  class="mr-4"
                  v-if="codigo"
                  @click="resetSub"
                >
                  Limpar
                  <v-icon left>
                    mdi-broom
                  </v-icon>
                </v-btn>
                <v-btn
                  color="danger"
                  class="mr-4"
                  @click="dialog.value = false"
                >
                  Sair
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-card>
        </template>
      </v-dialog>
    </v-container>
    <!-- fim da tela de atualização do submenu -->
    <v-container>
      <v-dialog
        v-model="addFoto"
        transition="dialog-top-transition"
      >
        <template v-slot:default="dialog">
          <v-card>
            <v-toolbar
              color="primary"
              dark
            >
              Adicionar mídia
            </v-toolbar>
            <v-card
              elevation="2"
              class="pa-3"
            >
              <div class="ma-5">
                <PageTitle
                  icon="mdi-pencil-box-outline"
                  sub="Adicionar ícone ao menu"
                />
                <v-form>
                  <v-row>
                    <v-col
                      cols="12"
                      md="2"
                    >
                      <v-text-field
                        v-model="codigo"
                        label="Código"
                        dense
                        filled
                      >
                      </v-text-field>
                    </v-col>
                  </v-row>
                  <v-row>
                    <input
                      accept="image/png, image/jpeg, image/bmp"
                      prepend-icon="mdi-camera"
                      label="Arquivo de imagem"
                      v-if="uploadReady"
                      type="file"
                      ref="file"
                      @change="selectFile()"
                    >
                  </v-row>
                </v-form>
              </div>
              <v-card-actions class="justify-end">
                <v-btn
                  color="success"
                  class="mr-4"
                  v-if="codigo"
                  type="submit"
                  @click.prevent="fileUpload()"
                >
                  <v-icon left>
                    mdi-content-save
                  </v-icon>
                  Salvar
                </v-btn>
                <v-btn
                  color="error"
                  class="mr-4"
                  v-if="codigo"
                  @click="clearUpload"
                >
                  Remover teste
                  <v-icon left>
                    mdi-broom
                  </v-icon>
                </v-btn>
                <v-btn
                  color="danger"
                  class="mr-4"
                  @click="dialog.value = false"
                >
                  Sair
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-card>
        </template>
      </v-dialog>
    </v-container>
    <v-container>
      <v-dialog
        v-model="addFotoSub"
        transition="dialog-top-transition"
      >
        <template v-slot:default="dialog">
          <v-card>
            <v-toolbar
              color="primary"
              dark
            >
              Adicionar mídia
            </v-toolbar>
            <v-card
              elevation="2"
              class="pa-3"
            >
              <div class="ma-5">
                <PageTitle
                  icon="mdi-pencil-box-outline"
                  sub="Adicionar ícone ao submenu"
                />
                <v-form>
                  <v-row>
                    <v-col
                      cols="12"
                      md="2"
                    >
                      <v-text-field
                        v-model="codigo"
                        label="Código"
                        dense
                        filled
                      >
                      </v-text-field>
                    </v-col>
                  </v-row>
                  <v-row>
                    <input
                      accept="image/png, image/jpeg, image/bmp"
                      prepend-icon="mdi-camera"
                      label="Arquivo de imagem"
                      v-if="uploadReady"
                      type="file"
                      ref="file"
                      @change="selectFile()"
                    >
                  </v-row>
                </v-form>
              </div>
              <v-card-actions class="justify-end">
                <v-btn
                  color="success"
                  class="mr-4"
                  v-if="codigo"
                  type="submit"
                  @click.prevent="fileUploadSub()"
                >
                  <v-icon left>
                    mdi-content-save
                  </v-icon>
                  Salvar
                </v-btn>
                <v-btn
                  color="error"
                  class="mr-4"
                  v-if="codigo"
                  @click="clearUpload"
                >
                  Remover teste
                  <v-icon left>
                    mdi-broom
                  </v-icon>
                </v-btn>
                <v-btn
                  color="danger"
                  class="mr-4"
                  @click="dialog.value = false"
                >
                  Sair
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-card>
        </template>
      </v-dialog>
    </v-container>
  </v-card>
</template>

<script>
import PageTitle from '@/components/template/PageTitle'
import { mapState } from 'vuex'
import { uuid } from 'vue-uuid'
import { baseApiUrl, showError } from '@/global'
import axios from 'axios'
export default {
  name: 'MenuSite',
  components: { PageTitle },
  computed: mapState(['user']),
  data: () => ({
    uuid: '',
    tabs: null,
    codigo: '',
    addFoto: false,
    addFotoSub: false,
    uploadReady: true,
    dialog: false,
    addSubmenu: false,
    editSubmenu: false,
    pasta: 'menuSite',
    tabelamenu: 'menusite',
    tabelasubmenu: 'submenusite',
    search: '',
    mode: 'save',
    grupos: [],
    parent: [],
    menu: {},
    menus: [],
    submenu: {},
    submenus: [],
    length: '',
    targets: [
      { value: '_top', text: '_top' },
      { value: '_self', text: '_self' },
      { value: '_blank', text: '_blank' }
    ],
    headers: [
      {
        text: 'Cód',
        align: 'start',
        sortable: false,
        value: 'id'
      },
      { text: 'Nome do menu', value: 'nome' },
      { text: 'Bloco do menu', value: 'bloco' },
      { text: 'Descrição', value: 'ds_menu' },
      { text: 'Ícone', value: 'png_menu' },
      { text: 'Situação', value: 'inativar', sortable: false },
      { text: 'Ações', value: 'actions', sortable: false }
    ],
    headersSub: [
      {
        text: 'Cód',
        align: 'start',
        sortable: false,
        value: 'id'
      },
      { text: 'Submenu', value: 'nome' },
      { text: 'Posição', value: 'posicao' },
      { text: 'Link interno', value: 'url_int' },
      { text: 'Icone', value: 'size' },
      { text: 'Componente', value: 'component' },
      {
        text: 'Situação',
        value: 'inativar',
        sortable: false,
        formatter: value => value ? 'Sim' : 'Não'
      },
      { text: 'Ações', value: 'actions', sortable: false }
    ],
    valid: false
  }),
  methods: {
    save () {
      const method = this.menu.id ? 'put' : 'post'
      const id = this.menu.id ? `/${this.menu.id}` : ''
      axios[method](`${baseApiUrl}/menu-site-pa${id}`, this.menu)
        .then(() => {
          this.$toasted.global.defaultSuccess()
          this.reset()
        })
        .catch(showError)
    },
    saveSub () {
      const method = this.submenu.id ? 'put' : 'post'
      const id = this.submenu.id ? `/${this.submenu.id}` : ''
      axios[method](`${baseApiUrl}/menu-site-pa${id}`, this.submenu)
        .then(() => {
          this.$toasted.global.defaultSuccess()
          this.resetSub()
          this.loadSubmenus()
        })
        .catch(showError)
    },
    selectFile () {
      this.file = this.$refs.file.files[0]
    },
    async fileUpload () {
      const formData = new FormData()
      const idIC = this.menu.id
      const url = `${baseApiUrl}/midia-icon-menu/${idIC}`
      formData.append('subpasta', this.menu.id)
      formData.append('pasta', this.pasta)
      formData.append('tabela', this.tabelamenu)
      formData.append('file', this.file)
      await axios.put(url, formData)
        .then(() => {
          this.$toasted.global.defaultSuccess()
        })
        .catch(showError)
    },
    async fileUploadSub () {
      const formData = new FormData()
      const idIC = this.submenu.id
      const url = `${baseApiUrl}/midia-icon-menu/${idIC}`
      formData.append('subpasta', this.submenu.id)
      formData.append('pasta', this.pasta)
      formData.append('tabela', this.tabelasubmenu)
      formData.append('file', this.file)
      await axios.put(url, formData)
        .then(() => {
          this.$toasted.global.defaultSuccess()
        })
        .catch(showError)
    },
    remove () {
      alert('Deseja realmente remover?')
    },
    loadMenus () {
      const url = `${baseApiUrl}/filtro-menu-site-pa`
      axios.get(url).then(res => {
        this.menus = res.data
      })
    },
    loadSubmenus () {
      const idC = this.menu.id
      const url = `${baseApiUrl}/submenus-pa/${idC}`
      axios.get(url).then(res => {
        this.submenus = res.data
      })
    },
    loadMenu (menu, mode = 'save') {
      this.mode = mode
      const id = menu.id
      const url = `${baseApiUrl}/menu-site-pa-update/${id}`
      axios.get(url).then(res => {
        this.menu = res.data
        this.loadParent()
      })
      this.codigo = menu.id
      this.dialog = false
      this.valid = true
      // this.loadSubmenus()
    },
    loadGrupos () {
      const url = `${baseApiUrl}/grupo-de-menus-pa`
      axios.get(url).then(res => {
        this.grupos = res.data.map(item => {
          return {
            value: item.id,
            text: item.gp_nome
          }
        })
      })
    },
    loadParent () {
      const id = this.menu.grupoId
      const url = `${baseApiUrl}/menus-do-grupo-pa/${id}`
      axios.get(url).then(res => {
        this.parent = res.data.map(parent => {
          return {
            value: parent.id,
            text: parent.nome
          }
        })
      })
    },
    loadSub (submenu, mode = 'save') {
      const id = submenu.id
      const url = `${baseApiUrl}/menu-site-pa-update/${id}`
      axios.get(url).then(res => {
        this.submenu = res.data
      })
      this.mode = mode
      this.editSubmenu = true
    },
    reset () {
      this.mode = 'save'
      this.menu = {}
      this.codigo = ''
      this.submenus = []
      this.loadUser()
    },
    resetSub () {
      this.submenu = {}
      this.submenu.usuario = this.user.id
      this.submenu.parentId = this.menu.id
      this.submenu.grupoId = this.menu.grupoId
      this.submenu.uuid = uuid.v1()
    },
    loadDialog () {
      this.dialog = true
      this.loadMenus()
    },
    loadAddSub () {
      this.submenu = {}
      this.submenu.uuid = uuid.v1()
      this.submenu.usuario = this.user.id
      this.submenu.parentId = this.menu.id
      this.submenu.grupoId = this.menu.grupoId
      this.addSubmenu = true
    },
    loadAddFoto () {
      this.addFoto = true
    },
    loadAddFotoSub () {
      this.addFotoSub = true
    },
    addSair () {
      this.saveSub()
      this.addSubmenu = false
    },
    addCont () {
      this.saveSub()
    },
    loadUser () {
      this.menu.uuid = uuid.v1()
      this.menu.usuario = this.user.id
    }
  },
  mounted () {
    this.loadUser()
    this.loadGrupos()
  }
}
</script>

<style scoped>
.container {
  width: 98% !important;
}
</style>
